import Axios from 'axios';
import { Message } from 'element-ui';

const API_CONTEXT = process.env.BUILD_ENV === 'prod' ? '/dadi' : '/sanggou';

// 实例化一个对象，避免全局污染
const http = Axios.create({
  timeout: 30 * 1000,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
  withCredentials: true,
});

// 数据转换
http.defaults.transformResponse = [(data) => {
  if (!data) {
    return data;
  }

  if (typeof data === 'string') {
    try {
      data = JSON.parse(data);
    } catch (e) {
      return data;
    }
  }

  return data;
}];

http.interceptors.request.use((config) => {
  // GET请求加上时间戳
  if (config.method === 'get') {
    let params = config.params;
    if (params == null) {
      params = { _: Date.now() };
    } else if (typeof params === 'object') {
      Object.assign(params, { _: Date.now() });
    }
    config.params = params;
  }

  if (!/^https:\/\//.test(config.url)) {
    config.url = API_CONTEXT + config.url;
  }

  return config;
}, error => Promise.reject(error));


function handleError(error) {
  // 配置了 noCatch: true 不处理
  if (error.config && error.config.noCatch) {
    return Promise.reject(error);
  }

  let message = '';

  if (error instanceof Error) {
    if (/timeout/i.test(error.message)) {
      message = '请求超时';
    } else {
      message = '网络异常，请检查网络';
    }
  } else if (error.data && error.data.message) {
    message = error.data.message;
  } else if (error.status) {
    switch (error.status) {
      case 404:
        message = '接口访问失败 404';
        break;
      case 503:
        message = '服务器临时不可用';
        break;
      default:
        message = '服务器异常';
    }
  }

  if (message) {
    Message.error(message);
  }
  return Promise.reject(error);
}

// 返回数据处理
http.interceptors.response.use((response) => {
  const responseData = response.data;

  if (responseData) {
    if (responseData.status !== '00') {
      return handleError(response);
    }
  }

  return responseData;
}, handleError);

export default http;
